document.addEventListener("DOMContentLoaded", () => {
    const inputValueCommissionDuration = document.getElementById(
        "commission-duration"
    );
    const inputValueDirectDuration = document.getElementById("direct-duration");

    const toggleCommissionDuration = document.getElementById(
        "never-commission-duration"
    );
    const toggleDirectDuration = document.getElementById(
        "never-direct-duration"
    );

    if (inputValueCommissionDuration && toggleCommissionDuration) {
        toggleCommissionDuration.addEventListener("change", (e) => {
            const checked = e.target.checked;

            if (checked) {
                inputValueCommissionDuration.readOnly = true;
                inputValueCommissionDuration.value = "";

                return;
            }
            inputValueCommissionDuration.readOnly = false;
        });
    }

    if (inputValueDirectDuration && toggleDirectDuration) {
        toggleDirectDuration.addEventListener("change", (e) => {
            const checked = e.target.checked;

            if (checked) {
                inputValueDirectDuration.readOnly = true;
                inputValueDirectDuration.value = "";

                return;
            }
            inputValueDirectDuration.readOnly = false;
        });
    }
});
